import {countOf} from '@features/admin-panel/helpers/admin-dashboard-text';
import {
  AdminDashboardDrillCell,
  AdminDashboardDrillRowBase,
  AdminDashboardDrillRowView
} from '@features/admin-panel/models/admin-dashboard-drill.models';

/** The period as a drill says it ("… in the last 30 days"). */
const PERIOD_LONG: {[key: string]: string} = {'7d': '7 days', '30d': '30 days', '90d': '90 days', '12m': '12 months'};

/** '7d' → '7 days', '30d' → '30 days', '90d' → '90 days', '12m' → '12 months'; anything else (or none) → '30 days'. */
export function adbPeriodLong(period?: string | null): string {
  return PERIOD_LONG[period ?? '30d'] ?? PERIOD_LONG['30d'];
}

/**
 * The line under a company in a drill (Plan ITP-P-35 Q2: owner and seats instead of the mockup's country and size):
 * "Jane Doe · 12 seats"; without seats "Jane Doe"; without an owner (a company not in Client Manager)
 * "Not in Client Manager". A client with no SalesContact arrives as ownerName "Unassigned" and reads "Unassigned · 4 seats".
 */
export function adbDrillMeta(row: AdminDashboardDrillRowBase): string {
  if (!row?.ownerName) {
    return 'Not in Client Manager';
  }
  return row.seats === null || row.seats === undefined ? row.ownerName : `${row.ownerName} · ${countOf(row.seats, 'seat')}`;
}

/** One drill row as the dialog draws it: the company, its meta line and the drill's own cells. */
export function adbDrillRowView(row: AdminDashboardDrillRowBase, cells: AdminDashboardDrillCell[]): AdminDashboardDrillRowView {
  return {companyId: row.companyId, companyName: row.companyName || row.companyId, meta: adbDrillMeta(row), cells};
}
